import { useParams } from "react-router-dom"
import { useEffect, useState } from "react"
import useStore from "../../../store"
import { useIsMobile } from "../../../hooks/useIsMobile"
import { Image } from "@chakra-ui/react"
import Spinner from "../../common/Spinner"
import { HappyButton, RedButton } from "../../common/Buttons"
import UnitWarningContainer from "../UnitPage/UnitWarningContainer"

export default function CouponInfoPage({ couponId }) {
  const id = useParams()
  const fetchCoupon = useStore((state) => state.fetchCoupon)
  const coupon = useStore((state) => state.coupon)
  const createCouponRedemption = useStore((state) => state.createCouponRedemption)
  const dealer = useStore((state) => state.dealer)
  const couponWithId = couponId || id.id
  const setCouponInfoPageId = useStore((state) => state.setCouponInfoPageId)
  const isMobile = useIsMobile()
  const fetchCoupons = useStore((state) => state.fetchCoupons)
  const isFetchingCoupon = useStore((state) => state.isFetchingCoupon)
  const isCreatingCouponRedemption = useStore((state) => state.isCreatingCouponRedemption)
  const sendPlaidLink = useStore((state) => state.sendPlaidLink)
  const isSendingPlaidLink = useStore((state) => state.isSendingPlaidLink)
  const [isPlaidLinkSent, setIsPlaidLinkSent] = useState(false)
  const user = useStore((state) => state.user)
  const fetchDealer = useStore((state) => state.fetchDealer)

  // Reload dealer so we get the latest value for has-plaid-connection
  useEffect(() => {
    fetchDealer(user.dealerId)
  }, [])

  useEffect(() => {
    if (couponWithId !== coupon?.id) {
      fetchCoupon(couponWithId)
    }
  }, [couponWithId, coupon])

  const handleCouponClick = async (optedInValue) => {
    setCouponInfoPageId(null)
    if (isMobile) {
      window.history.back()
    }
    await createCouponRedemption(couponWithId, dealer.id, optedInValue)
    fetchCoupons()
  }

  const handleSendPlaidLinkClick = async () => {
    const isSent = await sendPlaidLink()
    setIsPlaidLinkSent(isSent)
  }

  const isMissingRequiredPlaidConnection = () => {
    return !!coupon?.attributes['requires-plaid'] && !dealer?.attributes['has-plaid-connection']
  }

  return(
    <div className='flex grow overflow-y-auto w-full justify-center'>
      {!isFetchingCoupon ?
        <div className="flex flex-col items-start w-full mt-3">
          {coupon?.attributes['flyer-photo-url'] && (
            <div className="flex justify-center w-full mt-4">
              <Image
                src={coupon?.attributes['flyer-photo-url']}
                alt="Coupon Banner"
                borderRadius="md"
                maxW={{ base: "100vw", md: "85vw" }}
                maxH={{ base: "100vh", md: "75vh" }}
                objectFit="contain"
                width="100%"
                height="100%"
                pr={2}
                pl={2}
              />
            </div>
          )}
          {isMissingRequiredPlaidConnection() && (
            <div className="flex w-full mt-4 pr-4">
              <UnitWarningContainer colorStyles="text-yellow border-yellow">
                <span className="p-2 text-center">
                  This promotion requires a Plaid bank connection. Please connect your bank account through Plaid to opt in.
                </span>
              </UnitWarningContainer>
            </div>
          )}
          {isCreatingCouponRedemption ?
            <div className="flex w-full justify-center my-2 mt-4 pr-2">
              <Spinner/>
            </div>
          :
            <div className="flex w-full justify-between my-2 mt-4 p-2">
              <RedButton
                text={'Opt Out'}
                onClick={() => handleCouponClick(false)}
              />
              {isMissingRequiredPlaidConnection() ?
                <HappyButton
                  text={isPlaidLinkSent ? 'Plaid Email Sent' : 'Email Me a Plaid Link'}
                  onClick={handleSendPlaidLinkClick}
                  loading={isSendingPlaidLink}
                  disabled={isSendingPlaidLink || isPlaidLinkSent}
                />
              :
                <HappyButton
                  text={'Opt In'}
                  onClick={() => handleCouponClick(true)}
                />
              }
            </div>
          }
        </div>
      :
      <div className="flex flex-col items-center w-full mt-3">
        <Spinner/>
      </div>
      }
    </div>
  )
}